export default __webpack_public_path__ + "static/media/page29.6a37c847.jpg";